import { ProgressEvent } from '../../../adapters';
import {
    ContentDuration,
    IContent,
    MediaControllerState,
    PlanetMediaPlayer,
    PlanetUserInteractionArgs,
    PlaybackSessionState,
    TimeSpan,
} from '../../../media-player';
import { EventEmitterBase, IDisposable } from '../../../utils';
import { OnError, OnUserInteraction } from '../../models';
import { BrowserConsoleTrackerOptions } from './models';

export abstract class PlaybackSessionTracker<Type, Options> extends EventEmitterBase
    implements BrowserConsoleTrackerOptions, IDisposable, OnUserInteraction, OnError {

    protected player: PlanetMediaPlayer;

    protected options: Options;

    abstract trackStateChange(oldState: MediaControllerState, newState: MediaControllerState): void;

    abstract trackSessionCreate(session: PlaybackSessionState): void;

    abstract trackSessionEnd(session: PlaybackSessionState): void;

    abstract trackContentLoad(content: IContent, index: number): void;

    abstract trackPlaybackStart(position: number, duration: ContentDuration): void;

    abstract trackPlaybackResume(position: number, duration: ContentDuration): void;

    abstract trackPlaybackPause(position: number, duration: ContentDuration, state: MediaControllerState, played: TimeSpan): void;

    abstract trackSeek(position: number): void;

    abstract onBufferChange(data: ProgressEvent): void;

    abstract onUserInteraction(event: PlanetUserInteractionArgs);

    abstract onError(error: Error): void;

    abstract onSetupError(setupError: Error): void;

    abstract trackPlaybackComplete(): void;

    abstract dispose(): void;

    async setup(player: PlanetMediaPlayer, options: Options): Promise<PlaybackSessionTracker<Type, Options>> {
        this.player = player;
        this.options = options;
        return this;
    }

}
